
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class GavelEndCircle extends Vue {

    @Prop({required: false})
    completed!: boolean;

    @Prop({required: false})
    stepTitle!: string;

    @Prop({required: false})
    titleStyle!: string;

    public action(){
        this.$emit('action')
    }

}
